<template>
  <div>
    <v-chip x-small :color="color" >
    {{color}}
    </v-chip>
  </div>
</template>

<script>
export default {
  name: 'LabelColorComponent',
  props:['color'],
}
</script>

<style scoped>

</style>
